const RECOVERABLE_AUTH_ERROR_MARKERS = [
  'missing refresh token',
  'missing_refresh_token',
  'invalid_grant',
  'login_required',
  // Silent SSO via the Auth0 iframe (prompt=none) can't show a consent
  // dialog. When a scope/audience change requires fresh consent, Auth0
  // returns these. Treat them as recoverable so the recovery path bounces
  // the user through an interactive login, which surfaces the dialog.
  'consent_required',
  'interaction_required',
];

/**
 * Identifies Auth0 errors that mean the local authenticated state can no
 * longer mint access tokens.
 *
 * These errors can happen after auth configuration changes, refresh-token
 * expiry, browser cache loss, or a revoked Auth0 session. The UI cannot keep
 * operating safely because every Rome request depends on a fresh access token.
 */
export function isRecoverableAuthSessionError(error: unknown): boolean {
  if (error === null || typeof error !== 'object') {
    return false;
  }

  const details: string[] = [];

  if (error instanceof Error) {
    details.push(error.name, error.message);
  }

  if ('error' in error && typeof error.error === 'string') {
    details.push(error.error);
  }

  if ('error_description' in error && typeof error.error_description === 'string') {
    details.push(error.error_description);
  }

  const normalized = details.join(' ').toLowerCase();
  return RECOVERABLE_AUTH_ERROR_MARKERS.some((marker) => normalized.includes(marker));
}
